import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'semantic-ui-react';
import styles from '../../Form.scss';

export default class RadioWidget extends React.Component {

  static propTypes = {
    value: PropTypes.string,
    schema: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange(e, data) {
    this.props.onChange(data.value);
  }

  render() {
    const { value, schema } = this.props;
    return (
      <div className={styles.responseField}>
        {schema.enum.map((option, index) =>
          <div key={index}>
            <Radio
              onChange={this.onChange}
              checked={value === option}
              style={{ paddingBottom: '1em' }}
              label={option}
              value={option}
            />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Renderer/Widgets/Radio.js